import Divider from "component/divider/divider";
import MainButton from "component/shared/mainButton/MainButton";
import React from "react";

const CustomizedSearchComponentWrapper = ({
  children,
  title,
  link,
  display = true,
  buttonText="more"
}) => {
  return display ? (
    <div>
      <div className="component-title mb-4">{title}</div>
      {children}
      {link && (
        <div className="row-r my-4">
          <MainButton link={link} text={buttonText} />
        </div>
      )}
      <Divider borderColor="#1F254B" borderWidth="2px" marginBottom={"20px"} />
    </div>
  ) : (
    <></>
  );
};

export default CustomizedSearchComponentWrapper;
